import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaUserPlus, FaTimes } from 'react-icons/fa';
import { API_URL } from '../config';

// ============================================
// "INVITE YOUR TEAM" NUDGE  (client dashboard)
// Shows ONCE, quietly, and only while the company still has a single login (you).
//   - Dismissing it is remembered on this browser, so it never nags on every login.
//   - It also disappears BY ITSELF the moment a second person is invited.
//   - Only the company's primary contact ever sees it (only they can invite).
// Everything is wrapped defensively: if the lookup fails the nudge simply stays hidden
// and the dashboard is unaffected.
// ============================================
export default function InviteTeamNudge() {
  const [show, setShow] = useState(false);

  const storageKey = () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      return `op_team_nudge_dismissed_${user.client_id || user.id || 'user'}`;
    } catch { return 'op_team_nudge_dismissed_user'; }
  };

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        if (localStorage.getItem(storageKey()) === '1') return;
        const r = await fetch(`${API_URL}/client/team`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` }
        });
        const d = await r.json();
        if (cancelled || !d || !d.success) return;
        const people = d.company_people || [];
        // Already got a team? Nothing to nudge about.
        if (people.length > 1) return;
        // Only the primary contact can invite - so only they should be nudged.
        const me = people.find((p) => p.is_me);
        if (!me || !me.is_primary) return;
        setShow(true);
      } catch { /* stay hidden - never break the dashboard */ }
    };
    load();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(storageKey(), '1'); } catch { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="mb-5 rounded-xl border px-4 py-3 flex flex-wrap items-center gap-3" style={{ borderColor: '#D1FAE9', backgroundColor: '#F0FDF9' }}>
      <FaUserPlus size={14} style={{ color: '#00A86B' }} />
      <p className="text-sm flex-1 min-w-[220px]" style={{ color: '#0A1929' }}>
        <strong>Working with colleagues?</strong> Give each of them their own login — including people who only need to request quotes.
      </p>
      <Link to="/client-team" className="px-3 py-1.5 rounded-lg text-xs font-semibold text-white" style={{ backgroundColor: '#00A86B' }}>
        Invite your team
      </Link>
      <button onClick={dismiss} title="Don't show this again" className="text-gray-400 hover:text-gray-600 shrink-0">
        <FaTimes size={12} />
      </button>
    </div>
  );
}
